export const GET_SESSION_POLL_REQUEST = 'GET_SESSION_POLL_REQUEST';
export const GET_SESSION_POLL_SUCCESS = 'GET_SESSION_POLL_SUCCESS';
export const GET_SESSION_POLL_FAILURE = 'GET_SESSION_POLL_FAILURE';

export function getSessionPolls(webinarKey, sessionKey) {
  return {
    type: GET_SESSION_POLL_REQUEST,
    payload: { webinarKey, sessionKey }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionPoll/SessionPollActions.js